module.exports = __webpack_public_path__ + "static/media/Discovery.940ce1fe.png";